import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { id: "athletics" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("section", { id: "banner" }, [
    /*#__PURE__*/ _createElementVNode("figure", { style: { "background-image": "url(/images/athletics/main-banner.jpg)" } }, [
        /*#__PURE__*/ _createElementVNode("img", {
            src: "/images/athletics/we-are-scots2.svg",
            alt: "We Are Scots"
        })
    ]),
    /*#__PURE__*/ _createElementVNode("div", { class: "gold-line" })
], -1 /* HOISTED */);
const _hoisted_3 = { id: "sport-list" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    const _component_SportList = _resolveComponent("SportList");
    return (_openBlock(), _createElementBlock("main", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("menu", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subpages, (sub) => {
                return (_openBlock(), _createElementBlock("li", { key: sub }, [
                    _createVNode(_component_router_link, {
                        to: { name: 'Athletics', params: { subpage: sub.toLowerCase() } }
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(sub != 'clubs' ? sub.toUpperCase() : 'CLUBS/TEAMS'), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                ]));
            }), 128 /* KEYED_FRAGMENT */))
        ]),
        _createElementVNode("section", _hoisted_3, [
            _createVNode(_component_SportList, { sports: _ctx.list }, null, 8 /* PROPS */, ["sports"])
        ])
    ]));
}
